import * as React from "react";
import { twMerge } from "tailwind-merge";

type GroupContainerProps = {
  children: React.ReactNode;
  className?: string;
};

export function GroupContainer({ children, className }: GroupContainerProps) {
  return (
    <div
      role="region"
      className={twMerge(
        " mx-auto w-11/12  shrink-0 overflow-hidden rounded-lg border border-b-2 border-stone-400 bg-white",
        className
      )}
    >
      {children}
    </div>
  );
}

export const GroupTitle = ({ children }: { children: React.ReactNode }) => (
  <h2
    className="border-t border-stone-400 bg-white py-2 text-center text-2xl text-stone-700"
    style={{ textShadow: "1px 1px 2px hsl(0deg 0% 10% / 10%)" }}
  >
    {children}
  </h2>
);
